<div class="d-none d-md-flex h-100 align-items-center justify-content-center ">
  <a routerLink="informations" routerLinkActive="active" ngbTooltip="Informations" tooltipClass="d-xl-none">
    <fa-icon size="lg" icon="bell"></fa-icon>
    <span class="d-none d-xl-inline ps-2"> Informations</span>
  </a>
  @if (!rolesService.isCollaborateur()) {
    <a [class]="rolesService.hasProduct() ? '' : 'menu-disabled'" [routerLink]="rolesService.hasProduct() ? 'tickets': ''"
      routerLinkActive="active"
      [ngbTooltip]="rolesService.hasProduct() ? 'Mes tickets d\'assistance' : 'Vous n\'avez accès à aucun produit. Merci de contacter votre référent Portail'"
      [tooltipClass]="rolesService.hasProduct() ? 'd-xl-none':''">
      <fa-icon size="lg" icon="sticky-note"></fa-icon>
      <span class="d-none d-xl-inline ps-2"> Mes tickets d'assistance</span>
    </a>
  }
  <div routerLinkActive="active" ngbTooltip="Ressources" class="h-100" placement="left" tooltipClass="d-xl-none"
    ngbDropdown display="static">
    <a href="javascript:void(0)" type="button" ngbDropdownToggle>
      <fa-icon size="lg" icon="book"></fa-icon>
      <span class="d-none d-xl-inline ps-2"> Ressources</span>
    </a>
    <div ngbDropdownMenu class="dropdown-menu">
      <a routerLink="faq" routerLinkActive="active" ngbDropdownItem>
        <fa-icon icon="comments"></fa-icon>
        <span class="ps-2"> FAQ</span>
      </a>
      <a routerLink="documentations" routerLinkActive="active" ngbDropdownItem>
        <fa-icon icon="file-pdf"></fa-icon>
        <span class="ps-2"> Documentations</span>
      </a>
      @if(allowedRnProducts.length > 1) {
        <a ngbDropdownItem type="button" href="javascript:void(0)" >
          <fa-icon icon="note-sticky"></fa-icon>
          <span class="ps-2"> Notes de version &nbsp;<fa-icon style="font-size:12px" icon="chevron-right"></fa-icon></span>
          <ul class="dropdown-menu dropdown-submenu">
            @for(p of allowedRnProducts; track p) {
              <li>
                <a [routerLink]="['notes-de-version', p.name]" class="dropdown-item" routerLinkActive="active">{{p.name}}</a>
              </li>
            }
          </ul>
        </a>
      } @else if(allowedRnProducts.length > 0) {
        <a [routerLink]="['notes-de-version', allowedRnProducts[0].name]" routerLinkActive="active" ngbDropdownItem>
          <fa-icon icon="note-sticky"></fa-icon>
          <span class="ps-2"> Notes de version</span>
        </a>
      }

    </div>
  </div>
  @if (rolesService.isReferent() && rolesService.hasProduct()) {
    <a routerLink="prestations" routerLinkActive="active"  ngbTooltip="Prestations" tooltipClass="d-xl-none"
      >
      <fa-icon size="lg" icon="calendar"></fa-icon>
      <span class="d-none d-xl-inline ps-2"> Prestations</span>
    </a>
  }
  <a routerLink="outils" routerLinkActive="active" ngbTooltip="Outils" tooltipClass="d-xl-none">
    <fa-icon size="lg" icon="sliders-h"></fa-icon>
    <span class="d-none d-xl-inline ps-2"> Outils</span>
  </a>
  @if (rolesService.isReferent()) {
    <div routerLinkActive="active" ngbTooltip="Gestion" class="h-100" placement="left" tooltipClass="d-xl-none"
      ngbDropdown display="static">
      <a href="javascript:void(0)" type="button" ngbDropdownToggle>
        <fa-icon size="lg" icon="university"></fa-icon>
        <span class="d-none d-xl-inline ps-2"> Gestion</span>
      </a>
      <div ngbDropdownMenu class="dropdown-menu">
        <a routerLink="utilisateurs" routerLinkActive="active" ngbDropdownItem>
          <fa-icon icon="users"></fa-icon>
          <span class="ps-2"> Utilisateurs</span>
        </a>
        <a routerLink="contrats" routerLinkActive="active" ngbDropdownItem>
          <fa-icon icon="file-contract"></fa-icon>
          <span class="ps-2"> Contrats</span>
        </a>
      </div>
    </div>
  }
</div>
